export default __webpack_public_path__ + "images/product/skin_types/oily-6d083acc254ad173c41f4610348dcf47.svg";